<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="组织管理">
      <a-button slot="extra" type="primary" @click="handleNewOrg">新建组织</a-button>
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="组织名称">
              <a-input
              v-model="searchP.organizationname"
                  placeholder="请输入组织名称或编码"
              ></a-input>
          </a-form-item>
          <a-form-item label="组织类型">
            <a-select v-model="searchP.organizationtype"  placeholder="">
                <a-select-option value="">
                全部
                </a-select-option>
                <a-select-option value="公司">
                公司
                </a-select-option>
                <a-select-option value="部门">
                部门
                </a-select-option>
                <a-select-option value="小组">
                小组
                </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="组织负责人">
              <a-input
              v-model="searchP.fullname"
                  placeholder="请输入组织负责人"
              ></a-input>
          </a-form-item>
          <a-form-item label="所属上级组织">
              <a-input
              v-model="searchP.uporganization"
                  placeholder="请输入组织名称或编码查询"
              ></a-input>
          </a-form-item>
          <a-form-item label="有效性">
            <a-select default-value="" v-model="searchP.isvalidity"  placeholder="">
                <a-select-option value="" >
                全部
                </a-select-option>
                <a-select-option value="1">
                有效
                </a-select-option>
                <a-select-option value="0">
                无效
                </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
              <a-button
                  type="primary"
                  htmlType="submit"
                  :key="this.loading.key"

              >筛选</a-button>
          </a-form-item>
          <a-form-item>
            <a-button
                    type="default"
                    htmlType="submit"
                    :key="this.loading.key"
                    @click="handleSearchReset"
                >重置</a-button>
            </a-form-item>
      </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="organizationcode" >
        <span slot="organizationleader" slot-scope="text">{{ text ? text : '/' }}</span>
        <span slot="isvalidity" slot-scope="text">{{ text == '1' ? '有效' : '无效' }}</span>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
         <span>
            <router-link
                    :to="{
                    path:'orgdetail',
                    query: {
                        organizationcode: record.organizationcode
                    }
                }"
                >查看</router-link>
          </span>
          <span>
            <router-link
                    :to="{
                    path:'orgedit',
                    query: {
                        organizationcode: record.organizationcode
                    }
                }"
                >编辑</router-link>
          </span>
          <span>
            <a-popconfirm title="确认修改？" @confirm="() => onOrgchange(record)">
              <a>{{ record.isvalidity == '1' ? '无效' : '有效' }}</a>
            </a-popconfirm>
          </span>

        </div>
      </template>
    </a-table>

    <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />


  </div>
</template>
<script>
const columns = [
    {
        title: '组织编码',
        dataIndex: 'organizationcode',
        align: 'center',
        width:80
    },
    {
        title: '组织名称',
        dataIndex: 'organizationname',
        align: 'center',
        width: 120,
        ellipsises:true
    },

    {
        title: '组织类型',
        dataIndex: 'organizationtype',
        align: 'center',
        width: 80,
    },
    // {
    //     title: '组织负责人',
    //     dataIndex: 'fullname',
    //     align: 'left',
    //     ellipsises:true
    // },
    {
        title: '上级组织名称',
        dataIndex: 'uporganizationname',
        align: 'left',
    },
    {
        title: '上级组织编码',
        dataIndex: 'uporganizationcode',
        align: 'left',
    },
    {
        title: '是否有效',
        dataIndex: 'isvalidity',
        scopedSlots: { customRender: 'isvalidity' },
        align: 'left',
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }
];



const data = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            searchP:{
                organizationname:'',//组织名称
                organizationtype:'',//组织类型
                fullname:'',//组织负责人
                uporganization:'',//所属上级组织
                uporganizationcode:'',//所属上级组织编码
                isvalidity:'',//有效性
                total:0,
                pageSize:0,
                page:undefined,
            },
            tLoading:true,
        };
    },
    methods: {
        getOrgList(){
            let c_params = {
                ...this.searchP,
                urlparams:false,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "orgcenter/selectOrg",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.searchP.total = result.totalRecords;
                this.searchP.pageSize = result.pageSize;
                this.searchP.page = result.page;
            })
        },
        handlePageChange(c_p){
            this.searchP.page = c_p;
            this.updateRoute();
        },
        updateRoute(){
            this.$router.push({
                query: {
                    ...this.searchP
                }
            });
        },
        handleSearchReset(){
            this.searchP.page = 1;
            this.searchP.organizationname = '';
            this.searchP.organizationtype = '';
            this.searchP.fullname = '';
            this.searchP.uporganization = '';
            this.searchP.uporganizationcode = '';
            this.searchP.isvalidity = '';

            this.updateRoute();
        },
        handleNewOrg(){
            this.$router.push({
                path: "orgadd",
                query: {id:''}
            });
        },
        handleSubmit(e){
            e.preventDefault();
            this.searchP.page = 1;
            this.updateRoute()
        },
        //改成无效
        onOrgchange(key) {
            let c_params = {
                organizationcode:key.organizationcode,
                isvalidity:key.isvalidity == '0' ? '1' : '0'
            }
            this.$store.dispatch({
                type: "orgcenter/activeOrg",
                params: c_params
            }).then((res) => {

                if(res.status == '200'){
                    this.getOrgList();
                }
            });
        },

    },
    computed:{

    },
    watch: {
        '$route' () {
            this.$router.go(0);
        }
    },
    components:{
    },
    mounted(){
        let query = this.$route.query;
        this.searchP.organizationname = query.organizationname ? query.organizationname : '';
        this.searchP.organizationtype = query.organizationtype ? query.organizationtype : '';
        this.searchP.fullname = query.fullname ? query.fullname : '';
        this.searchP.uporganization = query.uporganization ? query.uporganization : '';
        this.searchP.uporganizationcode = query.uporganizationcode ? query.uporganizationcode : '';
        this.searchP.isvalidity = query.isvalidity ? query.isvalidity : '';
        this.searchP.page = query.page ? +query.page : 1;
        this.getOrgList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
